import { defineMessages } from 'react-intl';

/**
 * Copy for the mic-test preview card (transcript → note generation demo in
 * onboarding). Shared descriptors live here rather than inline because most
 * are used as prop/attribute values (tab labels, pill labels, aria-labels)
 * or in more than one slot; the sibling preview variants
 * (`PreviewPanelContent`, `MicPermissionsPreview`)
 * can adopt them as they migrate off the legacy `t()` path.
 */
export const micTestPreviewMessages = defineMessages({
  defaultFirstName: {
    defaultMessage: 'Jane',
    id: 'sdXsqDjHw7',
    description:
      'Placeholder first name shown on the demo note signature before the user has entered their own',
  },
  defaultLastName: {
    defaultMessage: 'Doe',
    id: 'crDsJJ/2pk',
    description:
      'Placeholder last name shown on the demo note signature before the user has entered their own',
  },
  analyzingTranscript: {
    defaultMessage: 'Analyzing transcript',
    id: 'Jg67RFcPsA',
    description: 'Progress pill while the demo transcript is being analyzed',
  },
  creatingNote: {
    defaultMessage: 'Creating note',
    id: 'ILI+diyIEk',
    description: 'Progress pill while the demo clinical note is being generated',
  },
  transcript: {
    defaultMessage: 'Transcript',
    id: 'anUX+ejStQ',
    description: 'Tab label for the consultation transcript in the preview card',
  },
  clinicalNote: {
    defaultMessage: 'Clinical Note',
    id: 'naOWaPrEqK',
    description: 'Tab label and heading for the generated clinical note',
  },
  referralLetter: {
    defaultMessage: 'Referral Letter',
    id: 'G3uinADDkE',
    description: 'Fallback tab label for a generated referral letter document',
  },
  evidence: {
    defaultMessage: 'Evidence',
    id: '6NnLdHPqoC',
    description: 'Tab label for the Heidi Evidence panel',
  },
  transcribing: {
    defaultMessage: 'Transcribing',
    id: 'IaEYZsMYTs',
    description: 'Status label while the live demo transcript is being typed out',
  },
  transcribed: {
    defaultMessage: 'Transcribed',
    id: '6U/6vxSg9H',
    description: 'Status label once the live demo transcript has finished',
  },
  youllBeSaying: {
    defaultMessage: 'You’ll be saying',
    id: '7+C3gZzLo3',
    description:
      'Heading above the sample script the user reads aloud during the mic test',
  },
  closeReferralLetter: {
    defaultMessage: 'Close referral letter',
    id: '8cq+37agWi',
    description: 'Accessible label for the button that closes a referral letter tab',
  },
  closeEvidence: {
    defaultMessage: 'Close evidence',
    id: 'WKR8W8lDrH',
    description: 'Accessible label for the button that closes the Evidence tab',
  },
  addingDetailFromTranscript: {
    defaultMessage: 'Adding more detail from the transcript',
    id: 'HuothTQ/5M',
    description: 'Progress pill while the demo note regenerates with more detail',
  },
  itemsFromGuidelines: {
    defaultMessage:
      '{count, plural, one {# item from CSANZ guidelines} other {# items from CSANZ guidelines}}',
    id: 'GK6t8XlTsC',
    description: 'Count of Evidence suggestions awaiting approval in the demo note',
  },
  clinicianSpeaker: {
    defaultMessage: 'Clinician',
    id: 'x+FXvFVgPZ',
    description:
      'Speaker label for the clinician’s turns in the demo consultation transcript',
  },
  patientSpeaker: {
    defaultMessage: 'Patient',
    id: 'En8oRtBWLe',
    description:
      'Speaker label for the patient’s turns in the demo consultation transcript',
  },
});
